import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Container from '@material-ui/core/Container';
import { useParams } from "react-router-dom";

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { Button, Card, CardContent, Checkbox, FormControlLabel } from '@mui/material';
import { useHistory } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import ModuloPGM from './moduloPgm.js';
import ModuloSonoro from './ModuloSonoro/moduloSonoro.js';
import { Drawer, List, ListItem, ListItemText, Snackbar } from '@material-ui/core';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme, CssBaseline } from '@mui/material';
import { ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import { Paper, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        color: '#434343',
        fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
        fontSize: 14,
        backgroundColor: '#eeeeee',
        marginTop: theme.spacing(10),
    },
    container: {
        maxWidth: 400,
        padding: theme.spacing(4),
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
        backgroundColor: '#ffffff',
        borderRadius: 10,
        textAlign: 'center',
    },
    header: {
        color: '#0ee6b1',
        fontSize: 35,
        marginBottom: theme.spacing(2),
    },
    subHeader: {
        color: '#336859',
        fontSize: 30,
        marginBottom: theme.spacing(4),
    },
    fieldGroup: {
        marginBottom: theme.spacing(2),
    },
    button: {
        backgroundColor: '#00E1AA',
        color: '#ffffff',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        padding: theme.spacing(1, 4),
        '&:hover': {
            backgroundColor: '#00c196',
        },
    },
}));


const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};


export default function EditarEquipamento() {

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const updateTheme = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };
        updateTheme();
        window.addEventListener('darkModeChanged', updateTheme);
        window.addEventListener('storage', updateTheme);
        const timer = setInterval(updateTheme, 1500);
        return () => {
            window.removeEventListener('darkModeChanged', updateTheme);
            window.removeEventListener('storage', updateTheme);
            clearInterval(timer);
        };
    }, []);

    const theme = useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: {
                main: '#1976d2',
            },
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
            }
        },
    }), [darkMode]);

    const themeV4 = useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            primary: {
                main: '#1976d2',
            },
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
            }
        },
        overrides: darkMode ? {
            MuiOutlinedInput: {
                root: {
                    '& fieldset': {
                        borderColor: '#475569',
                    },
                    '&:hover fieldset': {
                        borderColor: '#94a3b8',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#38bdf8',
                    },
                },
                input: {
                    color: '#f8fafc',
                }
            },
            MuiInputLabel: {
                root: {
                    color: '#94a3b8',
                    '&.Mui-focused': {
                        color: '#38bdf8',
                    }
                }
            },
            MuiInputBase: {
                input: {
                    color: '#f8fafc',
                }
            }
        } : {}
    }), [darkMode]);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        Cookies.set("abaPaginaConta", newValue);
        setValue(newValue);

    }

    
    const [cameraUsuario, setCameraUsuario] = useState('admin');
    const [cameraSenha, setCameraSenha] = useState('');
    const [cameraStatus, setCameraStatus] = useState(1);
    const [protocolo, setProtocolo] = useState(0);
    const [cameraZona, setCameraZona] = useState('');
    const [busca1, setBusca1] = useState('MEMORIA_CAMERA_RTSP');
    const [busca2, setBusca2] = useState('MEMORIA_CAMERA_HTTP');
    const [busca3, setBusca3] = useState('NVR');
    const [busca4, setBusca4] = useState('LOCAL');

    const [canalGravacao, setCanalGravacao] = useState(0);
    const [temperaturaMinima, setTemperaturaMinima] = useState(0.0);
    const [temperaturaMaxima, setTemperaturaMaxima] = useState(100.0);
    const [emissividade, setEmissividade] = useState(0.95);
    const [unidadeTemperatura, setUnidadeTemperatura] = useState(0);
    const [listaNegraLpr, setListaNegraLpr] = useState('');
    const [listaBrancaLpr, setListaBrancaLpr] = useState('');
    const [presetAlarme, setPresetAlarme] = useState(1);
    const [velocidadePtz, setVelocidadePtz] = useState(5);
    const [movimentoBasicoReal, setMovimentoBasicoReal] = useState(0);

    const [ip, setIp] = useState(null);
    const [porta, setPorta] = useState(null);

    const [emailPitunnel, setEmailPitunnel] = useState('');
    const [passwordPitunnel, setPasswordPitunnel] = useState('');
    const [emailDataplicity, setEmailDataplicity] = useState('');
    const [passwordDataplicity, setPasswordDataplicity] = useState('');
    const [urlMonitor, setUrlMonitor] = useState('');
    const [urlBd, setUrlBd] = useState('');
    const [urlVnc, setUrlVnc] = useState('');
    const [urlVncWeb, setUrlVncWeb] = useState('');
    const [urlSshWeb, setUrlSshWeb] = useState('');
    const [urlPingRede, setUrlPingRede] = useState('');
    const [urlAgentDVR, setUrlAgentDVR] = useState('');


    const [modelo, setModelo] = useState(null);
    const [numeroSerie, setNumeroSerie] = useState(null);

    const [posicaoInstalacao, setPosicaoInstalacao] = useState(0);
    const [delayRegistro, setDelayRegistro] = useState(10);


    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);


    const [modulosPgms, setModulosPgms] = useState(null);
    const [modulosSonoros, setModulosSonoros] = useState(null);


    const handleInsumo = (insumo) => {
        setInsumoSelecionado(insumo);
    }


    const [moduloPgmSelecionado, setModuloPgmSelecionado] = useState(null);
    const [moduloSonoroSelecionado, setModuloSonoroSelecionado] = useState(null);
    const [moduloSentinelSelecionado, setModuloSentinelSelecionado] = useState(null);
    const [integradoSigma, setIntegradoSigma] = useState(false);
    const [notificarArmeSigma, setNotificarArmeSigma] = useState(false);
    const [notificarDesarmeSigma, setNotificarDesarmeSigma] = useState(false);
    const [notificarAlarmeSigma, setNotificarAlarmeSigma] = useState(false);


    function returnDescricaoInsumo(insumo_) {

        try {
            let insumo = insumo_.insumo;
            let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

            if (insumo.variacoes && insumo.variacoes.length > 0) {
                textoComQuebraDeLinha += insumo.variacoes

                    .map((variacao, index) => (
                        `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                    )).join('');
            }

            var texto =

                //"<br />Marca/Modelo: " + insumo.marca + "/" + insumo.modelo +
                // "<br />Código Fornecedor: " + insumo.codigo_fornecedor +
                //"<br />Tipo: " + insumo.tipo +
                //"<br />Categoria: " + insumo.categoria +
                textoComQuebraDeLinha + "<br />Estoque: " + (Array.isArray(insumo_.itens_estoque) ? insumo_.itens_estoque.length : 0) + " unidades";
            return texto;
        } catch (_err) {

            try {
                let insumo = insumo_;
                let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

                if (insumo.variacoes && insumo.variacoes.length > 0) {
                    textoComQuebraDeLinha += insumo.variacoes

                        .map((variacao, index) => (
                            `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                        )).join('');
                }

                var texto =

                    //"<br />Marca/Modelo: " + insumo.marca + "/" + insumo.modelo +
                    // "<br />Código Fornecedor: " + insumo.codigo_fornecedor +
                    //"<br />Tipo: " + insumo.tipo +
                    //"<br />Categoria: " + insumo.categoria +
                    textoComQuebraDeLinha + "<br />Estoque: " + (Array.isArray(insumo.itens_estoque) ? insumo.itens_estoque.length : 0) + " unidades";
                return texto;
            } catch (_err) {
                return "INDEFINIDO";
            }
        }
    }






    function returnDescricaoStatus(status_item) {
        var texto = "";

        if (status_item === 0) {
            texto = "Disponível";
        }
        else if (status_item === 1) {
            texto = "Alugado";
        }
        else if (status_item === 2) {
            texto = "Vendido";
        }
        else if (status_item === 3) {
            texto = "Emprestado";
        }

        return texto
    }



    function returnDescricaoItemEstoque(item) {

        return "ID: " + item.id_item_estoque + "<br />" +
            "Status: " + returnDescricaoStatus(item.status_item) + "<br />" +
            "Fornecedor: " + (item.item.cotacao.fornecedor.tipo_fornecedor === 0 ? (item.item.cotacao.fornecedor.nome + " " + item.item.cotacao.fornecedor.sobrenome) : item.item.cotacao.fornecedor.nome_fantasia) + "<br />";


    }







    const { flagBack } = useParams();
    const { idCliente } = useParams();
    const { idInstalacao } = useParams();
    const { idEquipamento } = useParams();



    //const { idEquipamento } = useParams();



    const [rotaCamera, setRotaCamera] = useState(null);


    const [instalacao, setInstalacao] = useState(null);
    const [botaoClicado, setBotaoClicado] = useState(false);


    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [nomeMapa, setNomeMapa] = useState("");
    const [iconeMapa, setIconeMapa] = useState(0);

    const [ramal, setRamal] = useState("");
    const [localizacao, setLocalizacao] = useState("");


    const handleIconeMapa = (event) => {
        setIconeMapa(event.target.value);
    };


    function returnDescricaoModuloPgm(modulo) {
        var texto = "ID: " + modulo.id_modulo_pgm + "\n Código: " + modulo.codigo;
        return texto;
    }


    function returnDescricaoModuloSonoro(modulo) {
        var texto = "ID: " + modulo.id_modulo_sonoro + "\n Código: " + modulo.codigo;
        return texto;
    }



    const salvar = () => {
        // Verifica se o botão já foi clicado
        if (!botaoClicado) {
            // Executa a lógica do clique aqui
            console.log('Botão clicado!');

            // Atualiza o estado para indicar que o botão foi clicado
            setBotaoClicado(true);
            funcaoSalvar();
        }
    };



    const history = useHistory();



    async function funcaoSalvar() {


        try {

            const cadastro = {
                latitude: latitude,
                longitude: longitude,
                nome_mapa: nomeMapa,
                ip: ip,
                porta: porta,
                rota_camera: rotaCamera,
                localizacao: localizacao,
                ramal: ramal,
                numero_serie: numeroSerie,
                modelo: modelo,
                posicao_instalacao: posicaoInstalacao,
                delay_registro: delayRegistro,

            }

            if ((insumoSelecionado && insumoSelecionado.insumo) || insumoSelecionado) {

                if (insumoSelecionado && insumoSelecionado.insumo) {
                    cadastro.id_insumo = insumoSelecionado.insumo.id_insumo;
                    cadastro.tipo_equipamento_area_tecnica = insumoSelecionado.insumo.tipo_equipamento_area_tecnica;
                } else if (insumoSelecionado) {
                    cadastro.id_insumo = insumoSelecionado.id_insumo;
                    cadastro.tipo_equipamento_area_tecnica = insumoSelecionado.tipo_equipamento_area_tecnica;

                }
            } else {
                alert("Selecione o Insumo!");
                return;
            }




            //modulo pgm
            const idModuloPgm = moduloPgmSelecionado?.id_modulo_pgm || equipamento?.modulo_pgm?.id_modulo_pgm;
            if (idModuloPgm) {
                cadastro.modulo_pgm = {
                    id_modulo_pgm: idModuloPgm,
                    integrado_sigma: integradoSigma ? 1 : 0,
                    notificar_arme_sigma: notificarArmeSigma ? 1 : 0,
                    notificar_desarme_sigma: notificarDesarmeSigma ? 1 : 0,
                    notificar_alarme_sigma: notificarAlarmeSigma ? 1 : 0
                };
            }

            //modulo sonoro
            const idModuloSonoro = moduloSonoroSelecionado?.id_modulo_sonoro || equipamento?.modulo_sonoro?.id_modulo_sonoro;
            if (idModuloSonoro) {
                cadastro.modulo_sonoro = {
                    id_modulo_sonoro: idModuloSonoro,
                    email_pitunnel: emailPitunnel,
                    password_pitunnel: passwordPitunnel,
                    email_dataplicity: emailDataplicity,
                    password_dataplicity: passwordDataplicity,
                    url_monitor: urlMonitor,
                    url_bd: urlBd,
                    url_vnc: urlVnc,
                    url_vnc_web: urlVncWeb,
                    url_ssh_web: urlSshWeb,
                    url_ping_rede: urlPingRede,
                    url_agent_dvr: urlAgentDVR,
                    integrado_sigma: integradoSigma ? 1 : 0,
                    notificar_arme_sigma: notificarArmeSigma ? 1 : 0,
                    notificar_desarme_sigma: notificarDesarmeSigma ? 1 : 0,
                    notificar_alarme_sigma: notificarAlarmeSigma ? 1 : 0
                };
            }

            if (insumoSelecionado &&
                (insumoSelecionado.tipo_equipamento_area_tecnica === 8 ||
                    (insumoSelecionado.insumo && insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 8))) {

                if (posicaoInstalacao === null || posicaoInstalacao === undefined) {
                    alert("Selecione a Posição da Instalação do Sensor!");
                    setBotaoClicado(false);
                    return;
                }
                if (!delayRegistro || delayRegistro < 10) {
                    alert("O Delay de Registro deve ser um número maior ou igual a 10!");
                    setBotaoClicado(false);
                    return;
                }
            }

            
            if (insumoSelecionado && 
                ((parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 80) || 
                (insumoSelecionado.insumo && (parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 80)))) {
                cadastro.canal_gravacao = parseInt(canalGravacao, 10) || 0;
                cadastro.temperatura_minima = parseFloat(temperaturaMinima) || 0.0;
                cadastro.temperatura_maxima = parseFloat(temperaturaMaxima) || 100.0;
                cadastro.emissividade = parseFloat(emissividade) || 0.95;
                cadastro.unidade_temperatura = parseInt(unidadeTemperatura, 10) || 0;
                cadastro.lista_negra_lpr = listaNegraLpr || "";
                cadastro.lista_branca_lpr = listaBrancaLpr || "";
                cadastro.preset_alarme = parseInt(presetAlarme, 10) || 1;
                cadastro.velocidade_ptz = parseInt(velocidadePtz, 10) || 5;
                cadastro.movimento_basico_real = movimentoBasicoReal ? 1 : 0;

                cadastro.camera = { 
                    usuario: cameraUsuario, 
                    senha: cameraSenha, 
                    status: cameraStatus,
                    protocolo: parseInt(protocolo, 10),
                    zona: cameraZona,
                    busca_prioridade_1: busca1,
                    busca_prioridade_2: busca2,
                    busca_prioridade_3: busca3,
                    busca_prioridade_4: busca4,
                    canal_gravacao: parseInt(canalGravacao, 10) || 0,
                    temperatura_minima: parseFloat(temperaturaMinima) || 0.0,
                    temperatura_maxima: parseFloat(temperaturaMaxima) || 100.0,
                    emissividade: parseFloat(emissividade) || 0.95,
                    unidade_temperatura: parseInt(unidadeTemperatura, 10) || 0,
                    lista_negra_lpr: listaNegraLpr || "",
                    lista_branca_lpr: listaBrancaLpr || "",
                    preset_alarme: parseInt(presetAlarme, 10) || 1,
                    velocidade_ptz: parseInt(velocidadePtz, 10) || 5,
                    movimento_basico_real: movimentoBasicoReal ? 1 : 0
                };
            }

            //ramal
            if (insumoSelecionado && insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 120) {
                cadastro.ramal = ramal;
            }
            //ramal
            if (insumoSelecionado && parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 120) {
                cadastro.ramal = ramal;
            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/equipamentos/atualizar/' + idEquipamento, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {

                alert("Equipamento Atualizado");
                listarInformacoes();
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
                //setBotaoSalvarClickado(false);

            }

        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            setBotaoClicado(false);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }


    const [modulosPgmsAssociados, setModulosPgmsAssociados] = useState([]);
    const [modulosSonorosAssociados, setModulosSonorosAssociados] = useState([]);

    const [clienteSelecionado, setClienteSelecionado] = useState();

    const [clientes, setClientes] = useState();

    const [loading, setLoading] = useState(true);


    const [itemEstoqueSelecionado, setItemEstoqueSelecionado] = useState(null);

    const [equipamento, setEquipamento] = useState(null);


    const handleCliente = (event, cliente) => {

        setClienteSelecionado(cliente);
    };



    function returnDescricaoCliente(cliente) {
        console.log("Descricao de cliente chamada!");
        var texto = "ID: " + cliente.id_cliente + " " +
            (cliente.tipo_cliente === 0 ? ("CPF: " + cliente.cpf) : ("CNPJ: " + cliente.cnpj)) + " " +
            (cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) : cliente.nome_fantasia);

        return texto;
    }


    function returnDescricaoInstalacao(instalacao) {
        var texto = "ID_Integrador: " + instalacao.identificador_integrador + "\n Instalacao_ID: " + instalacao.id_instalacao + "\n CPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n Nome/Nome Fantasia: " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }



    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            let id_cliente = parseInt(idCliente);
            let id_instalacao = parseInt(idInstalacao);
            let flag = parseInt(flagBack);


            if (flag === 0) {
                await api.get("v1/protected/clientes/listarTodos", {
                    headers: headers
                }).then(function (response) {
                    setClientes(response.data)


                });


            } else if (flag === 1) {
                console.log("Flag é " + flag);

                setClientes([]);

                await api.get("/v1/protected/retornardadoscliente/" + id_cliente, {
                    headers: headers
                }).then(function (response) {
                    console.log("Dados de cliente retornado!");
                    setClienteSelecionado(response.data);

                    //listar instalacao
                    api.get("/v1/protected/cliente/instalacoes/listarporid/" + idInstalacao, {
                        headers: headers
                    }).then(function (response) {
                        setInstalacao(response.data);
                        console.log("Instalacao retornada!");

                        //listar o equipamento
                        api.get("v1/protected/equipamentos/listarporid/" + idEquipamento, {
                            headers: headers
                        }).then(function (response) {
                            console.log("Item estoque retornado!");

                            setEquipamento(response.data);
            if (response.data.camera) {
                setCameraUsuario(response.data.camera.usuario || 'admin');
                setCameraSenha(response.data.camera.senha || '');
                setCameraStatus(response.data.camera.status !== undefined ? response.data.camera.status : 1);
                setProtocolo(response.data.camera.protocolo !== undefined ? response.data.camera.protocolo : 0);
                setCameraZona(response.data.camera.zona || response.data.localizacao || '');
                setBusca1(response.data.camera.busca_prioridade_1 || 'MEMORIA_CAMERA_RTSP');
                setBusca2(response.data.camera.busca_prioridade_2 || 'MEMORIA_CAMERA_HTTP');
                setBusca3(response.data.camera.busca_prioridade_3 || 'NVR');
                setBusca4(response.data.camera.busca_prioridade_4 || 'LOCAL');

                setCanalGravacao(response.data.camera.canal_gravacao !== undefined ? response.data.camera.canal_gravacao : (response.data.canal_gravacao || 0));
                setTemperaturaMinima(response.data.camera.temperatura_minima !== undefined ? response.data.camera.temperatura_minima : (response.data.temperatura_minima || 0.0));
                setTemperaturaMaxima(response.data.camera.temperatura_maxima !== undefined ? response.data.camera.temperatura_maxima : (response.data.temperatura_maxima || 100.0));
                setEmissividade(response.data.camera.emissividade !== undefined ? response.data.camera.emissividade : (response.data.emissividade || 0.95));
                setUnidadeTemperatura(response.data.camera.unidade_temperatura !== undefined ? response.data.camera.unidade_temperatura : (response.data.unidade_temperatura || 0));
                setListaNegraLpr(response.data.camera.lista_negra_lpr || response.data.lista_negra_lpr || '');
                setListaBrancaLpr(response.data.camera.lista_branca_lpr || response.data.lista_branca_lpr || '');
                setPresetAlarme(response.data.camera.preset_alarme !== undefined ? response.data.camera.preset_alarme : (response.data.preset_alarme || 1));
                setVelocidadePtz(response.data.camera.velocidade_ptz !== undefined ? response.data.camera.velocidade_ptz : (response.data.velocidade_ptz || 5));
                setMovimentoBasicoReal(response.data.camera.movimento_basico_real !== undefined ? response.data.camera.movimento_basico_real : (response.data.movimento_basico_real || 0));
            } else {
                setCanalGravacao(response.data.canal_gravacao || 0);
                setTemperaturaMinima(response.data.temperatura_minima || 0.0);
                setTemperaturaMaxima(response.data.temperatura_maxima || 100.0);
                setEmissividade(response.data.emissividade || 0.95);
                setUnidadeTemperatura(response.data.unidade_temperatura || 0);
                setListaNegraLpr(response.data.lista_negra_lpr || '');
                setListaBrancaLpr(response.data.lista_branca_lpr || '');
                setPresetAlarme(response.data.preset_alarme || 1);
                setVelocidadePtz(response.data.velocidade_ptz || 5);
                setMovimentoBasicoReal(response.data.movimento_basico_real || 0);
            }


                            setLatitude(response.data.latitude);
                            setLongitude(response.data.longitude);
                            setNomeMapa(response.data.nome_mapa);
                            setLocalizacao(response.data.localizacao);

                            setRamal(response.data.ramal);

                            setModelo(response.data.modelo);
                            setNumeroSerie(response.data.numero_serie);

                            setPosicaoInstalacao(response.data.posicao_instalacao !== undefined ? response.data.posicao_instalacao : 0);
                            setDelayRegistro(response.data.delay_registro !== undefined ? response.data.delay_registro : 10);

                            setIp(response.data.ip);
                            setPorta(response.data.porta);
                            setRotaCamera(response.data.rota_camera);

                            console.log(response.data.insumo);
                            setInsumoSelecionado(response.data.insumo)
                            setItemEstoqueSelecionado(response.data.item_estoque);


                            setModuloPgmSelecionado(response.data.modulo_pgm);

                            setModuloSonoroSelecionado(response.data.modulo_sonoro);
                            setModuloSentinelSelecionado(response.data.modulo_sentinel);
                            if (response.data.modulo_sonoro) {
                                setEmailPitunnel(response.data.modulo_sonoro.email_pitunnel || '');
                                setPasswordPitunnel(response.data.modulo_sonoro.password_pitunnel || '');
                                setEmailDataplicity(response.data.modulo_sonoro.email_dataplicity || '');
                                setPasswordDataplicity(response.data.modulo_sonoro.password_dataplicity || '');
                                setUrlMonitor(response.data.modulo_sonoro.url_monitor || '');
                                setUrlBd(response.data.modulo_sonoro.url_bd || '');
                                setUrlVnc(response.data.modulo_sonoro.url_vnc || '');
                                setUrlVncWeb(response.data.modulo_sonoro.url_vnc_web || '');
                                setUrlSshWeb(response.data.modulo_sonoro.url_ssh_web || '');
                                setUrlPingRede(response.data.modulo_sonoro.url_ping_rede || '');
                                setUrlAgentDVR(response.data.modulo_sonoro.url_agent_dvr || '');
                                setIntegradoSigma(response.data.modulo_sonoro.integrado_sigma === 1);
                                setNotificarArmeSigma(response.data.modulo_sonoro.notificar_arme_sigma === 1);
                                setNotificarDesarmeSigma(response.data.modulo_sonoro.notificar_desarme_sigma === 1);
                                setNotificarAlarmeSigma(response.data.modulo_sonoro.notificar_alarme_sigma === 1);
                            } else if (response.data.modulo_pgm) {
                                setIntegradoSigma(response.data.modulo_pgm.integrado_sigma === 1);
                                setNotificarArmeSigma(response.data.modulo_pgm.notificar_arme_sigma === 1);
                                setNotificarDesarmeSigma(response.data.modulo_pgm.notificar_desarme_sigma === 1);
                                setNotificarAlarmeSigma(response.data.modulo_pgm.notificar_alarme_sigma === 1);
                            }

                        });

                    });
                });


            }

            api.get("v1/protected/almoxarifado/estoque/listarporinsumodisponiveis/" + idInstalacao, {
                headers: headers
            }).then(function (response) {
                setInsumos(response.data)

            });


            //pgms
            try {
                const response = await api.get("v1/protected/modulopgm/listardisponiveis", {
                    headers: headers
                });
                setModulosPgms(response.data);

                //modulos sonoros
                try {
                    const response = await api.get("v1/protected/modulosonoro/listardisponiveis", {
                        headers: headers
                    });
                    setModulosSonoros(response.data);
                    try {
                        const response = await api.get("v1/protected/modulopgm/listardisponiveisporinstalacao/" + idInstalacao, {
                            headers: headers
                        });
                        setModulosPgmsAssociados(response.data);
                        try {
                            const response = await api.get("v1/protected/modulosonoro/listardisponiveisporinstalacao/" + idInstalacao, {
                                headers: headers
                            });
                            setModulosSonorosAssociados(response.data);

                            setLoading(false);
                        } catch (error) {
                            console.error('Erro ao buscar módulos sonoros:', error);
                        }

                    } catch (error) {
                        console.error('Erro ao buscar módulos PGM:', error);
                    }
                } catch (error) {
                    console.error('Erro ao buscar módulos sonoros:', error);
                }

            } catch (error) {
                console.error('Erro ao buscar módulos PGM:', error);
            }


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar os Clientes: " + _err)
        }
    }

    useEffect(() => {

        listarInformacoes();


    }, []);



    const handleChange = (event, newValue) => {
        Cookies.set("abaPaginaConta", newValue);
        setValue(newValue);


    }




    async function handleClickCriarRamal() {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token"),
                'Content-Type': 'application/json'
            };

            const url = `/v1/protected/equipamentos/criarramal/${ramal}`;

            const response = await api.post(url, {}, { headers });

            // Sucesso
            const msg = response.data?.message || response.data || "Ramal criado com sucesso!";
            alert(msg);

        } catch (error) {

            // Erro do backend (mensagem enviada pelo seu ResponseEntity)
            if (error.response) {
                const msg = error.response.data?.message
                    || error.response.data
                    || "Erro ao criar ramal";
                alert("❌ Falha: " + msg);
            } else {
                // Erro de rede ou outro inesperado
                alert("❌ Erro inesperado: " + error.message);
            }

        }
    }


    const handleChangeIndex = (newValue) => {
        Cookies.set("abaPaginaConta", newValue);
        setValue(newValue);


    };

    function handleSetInstalacao(instalacao) {
        setInstalacao(instalacao);
    }


    const classes = useStyles();



    const handleOpenMap = (latitude, longitude) => {
        // Verifica se os valores de latitude e longitude são válidos
        if (latitude && longitude) {
            const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
            window.open(googleMapsUrl, '_blank');
        } else {
            alert('Coordenadas inválidas!');
        }
    };


    return (
        <MuiThemeProvider theme={theme}>
            <CoreThemeProvider theme={themeV4}>
                <CssBaseline />
                <div style={{ backgroundColor: darkMode ? '#121212' : '#ffffff', minHeight: '100vh', color: darkMode ? '#ffffff' : '#000000' }}>
                    <NavegadorGestao
                        BaseDados={true}
                        Projetos={true}
                        corFundo={darkMode ? '#1e293b' : 'white'}
                        travado={true}
                        corTexto={darkMode ? '#ffffff' : 'black'}
                    />
                    <div style={{ paddingTop: 5 }} />


                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :
                        <Container >

                            <React.Fragment >
                                <Grid container spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <Grid
                                        item xs={12}
                                        container
                                        direction="row"
                                        alignItems="center"
                                        justifyContent={"center"}
                                    >


                                        <Box style={{ backgroundColor: darkMode ? '#1e1e1e' : 'white', width: '100%', alignItems: 'center', }}>
                                            <AppBar position="static" >



                                                <Tabs
                                                    value={value}
                                                    onChange={handleChange}
                                                    indicatorColor="secondary"
                                                    textColor="inherit"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    aria-label="scrollable auto tabs example"
                                                    style={{ width: '100%', margin: 0, padding: 0 }}
                                                >
                                                    <Tab label="Informações Iniciais" style={{ backgroundColor: darkMode ? '#121212' : '#1C1C1C', color: 'white' }} />
                                                    {
                                                    (equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.modulo_pgm || moduloPgmSelecionado || (insumoSelecionado && (insumoSelecionado.tipo_equipamento_area_tecnica === 0 || insumoSelecionado.insumo?.tipo_equipamento_area_tecnica === 0))) ? (
                                                        <Tab label="Configurar PGM" style={{ backgroundColor: darkMode ? '#121212' : '#1C1C1C', color: 'white' }} />
                                                    ) :
                                                            
                                                            equipamento.tipo_equipamento_area_tecnica === 80 && equipamento.modulo_sonoro ? (
                                                                <Tab label="Configurar Câmera" style={{ backgroundColor: darkMode ? '#121212' : '#1C1C1C', color: 'white' }} />
                                                            ) :
equipamento.tipo_equipamento_area_tecnica === 30 ? (
                                                                <Tab label="Configurar Modulo Sonoro" style={{ backgroundColor: darkMode ? '#121212' : '#1C1C1C', color: 'white' }} />
                                                            ) :
                                                                (
                                                                    <Tab label="Configurar" style={{ backgroundColor: darkMode ? '#121212' : '#1C1C1C', color: 'white' }} />
                                                                )
                                                    }

                                                </Tabs>

                                            </AppBar>

                                        </Box>
                                    </Grid>





                                    <Grid
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                        style={{ width: '100%', alignItems: 'center', backgroundColor: darkMode ? '#121212' : 'white' }}
                                    >


                                        <SwipeableViews
                                            index={value}
                                            onChangeIndex={handleChangeIndex}
                                            style={{ margin: 0, padding: 0, backgroundColor: darkMode ? '#121212' : 'white', width: '100%' }}
                                        >

                                    <Grid
                                        value={value}
                                        index={0}
                                        style={{ paddingTop: 0, margin: 0 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            item xs={6}
                                        >
                                            <Button style={{ margin: 5 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={salvar}
                                                disabled={botaoClicado}
                                            > {botaoClicado ? "Atualizando..." : "Atualizar Informações"} </Button>
                                        </Grid>


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                            style={{ marginTop: 20 }}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={5}
                                            >

                                                <Autocomplete
                                                    id="select-ordem-servico"
                                                    options={flagBack === 0 ? clientes : []}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(cliente) => returnDescricaoCliente(cliente).replace(/<br \/>/g, '\n')}
                                                    value={clienteSelecionado}
                                                    disabled={flagBack === 0 ? false : true}
                                                    onChange={handleCliente}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((cliente) => {
                                                            const cotacaoText = returnDescricaoCliente(cliente).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label=" Cliente " multiline minRows={3} />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoCliente(option) }} />
                                                    )}

                                                />
                                            </Grid>
                                        </Grid>




                                        {clienteSelecionado &&
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ marginTop: 20 }}
                                            >
                                                <Grid
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={5}
                                                >

                                                    <Autocomplete
                                                        id="select-instalacao"
                                                        options={flagBack === 0 ? clienteSelecionado.instalacoes : []}
                                                        disableCloseOnSelect
                                                        getOptionLabel={(instalacao) => returnDescricaoInstalacao(instalacao).replace(/<br \/>/g, '\n')}
                                                        value={instalacao}
                                                        disabled={flagBack === 0 ? false : true}
                                                        onChange={(e, v) => handleSetInstalacao(v)}
                                                        filterOptions={(options, { inputValue }) => {
                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                            return options.filter((instalacao) => {
                                                                const cotacaoText = returnDescricaoInstalacao(instalacao).toLowerCase();
                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label=" Instalação " multiline minRows={3} />
                                                        )}
                                                        renderOption={(option) => (
                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoInstalacao(option) }} />
                                                        )}

                                                    />
                                                </Grid>

                                                <button
                                                    style={{
                                                        backgroundColor: '#003366', // Azul escuro
                                                        color: '#FFFFFF', // Texto branco
                                                        textAlign: 'center',
                                                        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)', // Sombra
                                                        padding: '10px', // Espaçamento interno
                                                        border: 'none',
                                                        borderRadius: '5px', // Borda arredondada opcional
                                                        cursor: 'pointer', // Alterar cursor ao passar o mouse
                                                    }}
                                                    onClick={(e) => handleOpenMap(instalacao.latitude, instalacao.longitude)}
                                                >
                                                    Mapa
                                                </button>
                                            </Grid>
                                        }




                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={8}
                                        >

                                            <Autocomplete
                                                id="select-insumo"
                                                options={insumos}
                                                getOptionLabel={(insumo) => returnDescricaoInsumo(insumo).replace(/<br \/>/g, '\n')}
                                                value={insumoSelecionado}
                                                getOptionSelected={(option, value) => true}
                                                onChange={(e, v) => handleInsumo(v)}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((insumo) => {
                                                        const insumoText = returnDescricaoInsumo(insumo).toLowerCase();
                                                        return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label=" Insumo " multiline minRows={2} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option) }} />
                                                )}
                                            />
                                        </Grid>

                                        <Grid

                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={6}>
                                                    <TextField

                                                        id="modelo"
                                                        variant="standard"
                                                        name="modelo"
                                                        fullWidth
                                                        label="Modelo"
                                                        value={modelo}
                                                        onChange={e => setModelo(e.target.value)}
                                                    />
                                                </Grid>

                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={6}>
                                                    <TextField

                                                        id="numeroSerie"
                                                        variant="standard"
                                                        name="numeroSerie"
                                                        fullWidth
                                                        label="Número de Serie"
                                                        value={numeroSerie}
                                                        onChange={e => setNumeroSerie(e.target.value)}
                                                    />
                                                </Grid>

                                            </Grid>


                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="ip"
                                                        variant="standard"
                                                        name="ip"
                                                        fullWidth
                                                        label="IP"
                                                        value={ip}
                                                        onChange={e => setIp(e.target.value)}
                                                    />
                                                </Grid>

                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="porta"
                                                        variant="standard"
                                                        name="porta"
                                                        fullWidth
                                                        label="Porta"
                                                        value={porta}
                                                        onChange={e => setPorta(e.target.value)}
                                                    />
                                                </Grid>

                                            </Grid>

                                        </Grid>

                                        {insumoSelecionado !== null &&

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={8}
                                            >

                                                <Autocomplete
                                                    id="select-item-estoque"
                                                    options={(insumoSelecionado && flagBack === 0) ? insumoSelecionado.itens_estoque : []}
                                                    getOptionLabel={(itemEstoque) => returnDescricaoItemEstoque(itemEstoque).replace(/<br \/>/g, '\n')}
                                                    value={itemEstoqueSelecionado}
                                                    disabled={flagBack === 0 ? false : true}
                                                    getOptionSelected={(option, value) => true}
                                                    onChange={(e, v) => setItemEstoqueSelecionado(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((insumo) => {
                                                            const insumoText = returnDescricaoItemEstoque(insumo).toLowerCase();
                                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label=" Item do Estoque " multiline minRows={2} />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoItemEstoque(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        }


                                        {insumoSelecionado !== null && itemEstoqueSelecionado && (itemEstoqueSelecionado.item.insumo.tipo_equipamento_area_tecnica === 0) &&

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={8}
                                            >

                                                <Autocomplete
                                                    id="select-modulo_pgm"
                                                    options={[]}
                                                    getOptionLabel={(modulo) => returnDescricaoModuloPgm(modulo).replace(/<br \/>/g, '\n')}
                                                    value={moduloPgmSelecionado}
                                                    disabled={flagBack === 0 ? false : true}
                                                    getOptionSelected={(option, value) => true}
                                                    onChange={(e, v) => setModuloPgmSelecionado(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((insumo) => {
                                                            const insumoText = returnDescricaoModuloPgm(insumo).toLowerCase();
                                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Módulo PGM " multiline minRows={2} />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoModuloPgm(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        }

                                        {insumoSelecionado !== null && itemEstoqueSelecionado && (itemEstoqueSelecionado.item.insumo.tipo_equipamento_area_tecnica === 30) &&

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={8}
                                            >

                                                <Autocomplete
                                                    id="select-modulo_sonoro"
                                                    options={[]}
                                                    disabled={flagBack === 0 ? false : true}
                                                    getOptionLabel={(modulo) => returnDescricaoModuloSonoro(modulo).replace(/<br \/>/g, '\n')}
                                                    value={moduloSonoroSelecionado}
                                                    getOptionSelected={(option, value) => true}
                                                    onChange={(e, v) => setModuloSonoroSelecionado(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((insumo) => {
                                                            const insumoText = returnDescricaoModuloSonoro(insumo).toLowerCase();
                                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Módulo Sonoro " multiline minRows={2} />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoModuloSonoro(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        }


                                        {insumoSelecionado !== null && (() => {
                                            const tipo = parseInt(insumoSelecionado.insumo ? insumoSelecionado.insumo.tipo_equipamento_area_tecnica : insumoSelecionado.tipo_equipamento_area_tecnica, 10);
                                            return tipo !== 0 && tipo !== 30;
                                        })() &&

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={8}
                                            >

                                                <Autocomplete
                                                    id="select-modulo_pgm"
                                                    options={(modulosPgmsAssociados && modulosPgmsAssociados.length > 0) ? modulosPgmsAssociados : (modulosPgms || [])}
                                                    getOptionLabel={(modulo) => returnDescricaoModuloPgm(modulo).replace(/<br \/>/g, '\n')}
                                                    value={moduloPgmSelecionado}
                                                    getOptionSelected={(option, value) => true}
                                                    onChange={(e, v) => setModuloPgmSelecionado(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((insumo) => {
                                                            const insumoText = returnDescricaoModuloPgm(insumo).toLowerCase();
                                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Módulo PGM associado" multiline minRows={2} />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoModuloPgm(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        }




                                        {insumoSelecionado !== null &&

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={8}
                                            >

                                                <Autocomplete
                                                    id="select-modulo_sonoro"
                                                    options={modulosSonorosAssociados}
                                                    getOptionLabel={(modulo) => returnDescricaoModuloSonoro(modulo).replace(/<br \/>/g, '\n')}
                                                    value={moduloSonoroSelecionado}
                                                    getOptionSelected={(option, value) => true}
                                                    onChange={(e, v) => setModuloSonoroSelecionado(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((insumo) => {
                                                            const insumoText = returnDescricaoModuloSonoro(insumo).toLowerCase();
                                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Módulo Unifier associado" multiline minRows={2} />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoModuloSonoro(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        }

                                        {insumoSelecionado !== null &&
                                            (insumoSelecionado.tipo_equipamento_area_tecnica === 8 ||
                                                (insumoSelecionado.insumo && insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 8)) &&

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={8}
                                            >

                                                <TextField
                                                    label="Módulo Sentinel associado"
                                                    multiline
                                                    minRows={2}
                                                    fullWidth
                                                    value={moduloSentinelSelecionado ? `ID: ${moduloSentinelSelecionado.id_modulo_sentinel} - Código: ${moduloSentinelSelecionado.codigo}` : 'Nenhum Módulo Sentinel associado'}
                                                    disabled
                                                    style={{ margin: 10 }}
                                                />

                                                <FormControl fullWidth style={{ marginTop: 20 }}>
                                                    <InputLabel id="posicao-label" style={{ color: darkMode ? 'white' : 'black' }}>Posição da Instalação do Sensor</InputLabel>
                                                    <Select
                                                        labelId="posicao-label"
                                                        id="posicao_instalacao"
                                                        value={posicaoInstalacao}
                                                        onChange={(e) => setPosicaoInstalacao(e.target.value)}
                                                        style={{ color: darkMode ? 'white' : 'black', textAlign: 'left' }}
                                                    >
                                                        <MenuItem value={0}>Horizontal</MenuItem>
                                                        <MenuItem value={1}>Vertical</MenuItem>
                                                    </Select>
                                                </FormControl>

                                                <TextField
                                                    id="delay_registro"
                                                    variant="standard"
                                                    name="delay_registro"
                                                    fullWidth
                                                    type="number"
                                                    label="Delay de Registro (em segundos)"
                                                    value={delayRegistro}
                                                    onChange={e => setDelayRegistro(e.target.value)}
                                                    inputProps={{ style: { color: darkMode ? 'white' : 'black' }, min: 10 }}
                                                    style={{ marginTop: 20 }}
                                                />

                                            </Grid>
                                        }
                                        {insumoSelecionado !== null &&
                                            (
                                                (insumoSelecionado.insumo && (parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 80 || parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 80)) ||
                                                (insumoSelecionado && (parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 80 || parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 80))
                                            )
                                            &&
                                            <Grid
                                                container
                                                direction="row"
                                                item xs={8}
                                                spacing={2}
                                                style={{ marginTop: 20, marginBottom: 20, border: darkMode ? '1px solid #444' : '1px solid #ccc', padding: 10, borderRadius: 5, backgroundColor: darkMode ? '#1e1e1e' : 'transparent' }}
                                            >
                                                <Grid item xs={12}>
                                                    <Typography variant="h6" style={{ color: darkMode ? 'white' : 'black' }}>Configurações de Câmera</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Usuário da Câmera" value={cameraUsuario} onChange={(e) => setCameraUsuario(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Senha da Câmera" type="password" value={cameraSenha} onChange={(e) => setCameraSenha(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Status (1 = Habilitado)</InputLabel>
                                                        <Select value={cameraStatus} onChange={(e) => setCameraStatus(e.target.value)}>
                                                            <MenuItem value={1}>Habilitado</MenuItem>
                                                            <MenuItem value={0}>Desabilitado</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField fullWidth label="Zona / Nome da Câmera (ex: Rua, Entrada)" value={cameraZona} onChange={(e) => setCameraZona(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Protocolo da Câmera</InputLabel>
                                                        <Select value={protocolo} onChange={(e) => setProtocolo(parseInt(e.target.value, 10))}>
                                                            <MenuItem value={0}>0 - Hikvision</MenuItem>
                                                            <MenuItem value={10}>10 - Intelbras</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Canal de Gravação</InputLabel>
                                                        <Select value={canalGravacao} onChange={(e) => setCanalGravacao(parseInt(e.target.value, 10))}>
                                                            <MenuItem value={0}>CANAL 1 (STREAM PRINCIPAL - FULL HD)</MenuItem>
                                                            <MenuItem value={1}>CANAL 2 (STREAM SECUNDÁRIO - SUBSTREAM)</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Temp. Mínima (°C / °F)" type="number" value={temperaturaMinima} onChange={(e) => setTemperaturaMinima(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Temp. Máxima (°C / °F)" type="number" value={temperaturaMaxima} onChange={(e) => setTemperaturaMaxima(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Emissividade (ex: 0.95)" type="number" value={emissividade} onChange={(e) => setEmissividade(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Unidade de Temperatura</InputLabel>
                                                        <Select value={unidadeTemperatura} onChange={(e) => setUnidadeTemperatura(parseInt(e.target.value, 10))}>
                                                            <MenuItem value={0}>0 - Celsius (°C)</MenuItem>
                                                            <MenuItem value={1}>1 - Fahrenheit (°F)</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Lista Negra LPR (Placas Alarme)" value={listaNegraLpr} onChange={(e) => setListaNegraLpr(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Lista Branca LPR (Placas Autorizadas)" value={listaBrancaLpr} onChange={(e) => setListaBrancaLpr(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Preset de Alarme PTZ" type="number" value={presetAlarme} onChange={(e) => setPresetAlarme(e.target.value)} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField fullWidth label="Velocidade PTZ (1 a 10)" type="number" value={velocidadePtz} onChange={(e) => setVelocidadePtz(e.target.value)} />
                                                </Grid>
                                                 <Grid item xs={12} style={{ marginTop: 10 }}>
                                                     <FormControlLabel
                                                         control={
                                                             <Checkbox
                                                                 checked={movimentoBasicoReal === 1}
                                                                 onChange={(e) => setMovimentoBasicoReal(e.target.checked ? 1 : 0)}
                                                                 color="primary"
                                                                 style={{ color: darkMode ? '#90caf9' : undefined }}
                                                             />
                                                         }
                                                         label={<span style={{ color: darkMode ? 'white' : 'black', fontWeight: 500 }}>Considerar Movimento Básico</span>}
                                                     />
                                                 </Grid>
                                                
                                                {[{label: 'Prioridade 1', val: busca1, set: setBusca1}, {label: 'Prioridade 2', val: busca2, set: setBusca2}, {label: 'Prioridade 3', val: busca3, set: setBusca3}, {label: 'Prioridade 4', val: busca4, set: setBusca4}].map((b, idx) => (
                                                    <Grid item xs={6} key={idx}>
                                                        <FormControl fullWidth>
                                                            <InputLabel>Modo de Busca - {b.label}</InputLabel>
                                                            <Select value={b.val} onChange={(e) => b.set(e.target.value)}>
                                                                <MenuItem value="MEMORIA_CAMERA_RTSP">Memória Câmera RTSP</MenuItem>
                                                                <MenuItem value="MEMORIA_CAMERA_HTTP">Memória Câmera HTTP</MenuItem>
                                                                <MenuItem value="NVR">NVR</MenuItem>
                                                                <MenuItem value="LOCAL">Local</MenuItem>
                                                                <MenuItem value="DESATIVADO">Desativado</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        }








                                        {insumoSelecionado !== null &&

                                            ((insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 120)
                                                ||
                                                (insumoSelecionado && parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 120)
                                            ) ||
                                            ((insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 30)
                                                ||
                                                (insumoSelecionado && parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 30)
                                            )
                                            &&

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={8}
                                            >
                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="ramal"
                                                        variant="standard"
                                                        name="ramal"
                                                        fullWidth
                                                        label="Ramal"
                                                        value={ramal}
                                                        onChange={e => {
                                                            const somenteNumeros = e.target.value.replace(/\D/g, '');
                                                            setRamal(somenteNumeros);
                                                        }}
                                                    />
                                                </Grid>


                                                <Grid item xs={3}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={(e) => handleClickCriarRamal()}
                                                        startIcon={<SwapHorizIcon />}
                                                        style={{ margin: 10 }}
                                                    >
                                                        Criar Ramal
                                                    </Button>
                                                </Grid>


                                            </Grid>

                                        }






                                        <Grid item xs={12}>
                                            <Grid item xs={12}>
                                                <Typography style={{ margin: 15 }} >
                                                    <span style={{ fontSize: 22, textDecoration: 'underline' }}>Dados de Mapa: </span>
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="nome_mapa"
                                                        variant="standard"
                                                        name="nome_mapa"
                                                        fullWidth
                                                        label="Nome Mapa"
                                                        value={nomeMapa}
                                                        onChange={e => setNomeMapa(e.target.value)}
                                                    />
                                                </Grid>

                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="localizacao"
                                                        variant="standard"
                                                        name="localizacao"
                                                        fullWidth
                                                        label="Localização"
                                                        value={localizacao}
                                                        onChange={e => setLocalizacao(e.target.value)}
                                                    />
                                                </Grid>

                                            </Grid>


                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12} spacing={2}
                                            >
                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="latitude"
                                                        variant="standard"
                                                        name="latitude"
                                                        fullWidth
                                                        label="Latitude"
                                                        value={latitude}
                                                        onChange={e => setLatitude(e.target.value)}
                                                    />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <TextField

                                                        id="longitude"
                                                        variant="standard"
                                                        name="longitude"
                                                        fullWidth
                                                        label="Longitude"
                                                        value={longitude}
                                                        onChange={e => setLongitude(e.target.value)}
                                                    />
                                                </Grid>
                                            </Grid>


                                            {insumoSelecionado && (
                                                (insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 30)
                                                ||
                                                (insumoSelecionado && parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 30)
                                            ) && (
                                                    <Grid item xs={12} style={{ marginTop: 20 }}>
                                                        <Typography style={{ margin: 15 }} >
                                                            <span style={{ fontSize: 22, textDecoration: 'underline' }}>Configurações de Conectividade: </span>
                                                        </Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TextField fullWidth label="E-mail PItunnel" variant="standard" margin="normal" value={emailPitunnel} onChange={(e) => setEmailPitunnel(e.target.value)} />
                                                                <TextField fullWidth label="Senha PItunnel" type="password" variant="standard" margin="normal" value={passwordPitunnel} onChange={(e) => setPasswordPitunnel(e.target.value)} />
                                                                <TextField fullWidth label="E-mail Dataplicity" variant="standard" margin="normal" value={emailDataplicity} onChange={(e) => setEmailDataplicity(e.target.value)} />
                                                                <TextField fullWidth label="Senha Dataplicity" type="password" variant="standard" margin="normal" value={passwordDataplicity} onChange={(e) => setPasswordDataplicity(e.target.value)} />
                                                                <TextField fullWidth label="URL Monitor" variant="standard" margin="normal" value={urlMonitor} onChange={(e) => setUrlMonitor(e.target.value)} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField fullWidth label="URL BD" variant="standard" margin="normal" value={urlBd} onChange={(e) => setUrlBd(e.target.value)} />
                                                                <TextField fullWidth label="URL VNC" variant="standard" margin="normal" value={urlVnc} onChange={(e) => setUrlVnc(e.target.value)} />
                                                                <TextField fullWidth label="URL VNC Web" variant="standard" margin="normal" value={urlVncWeb} onChange={(e) => setUrlVncWeb(e.target.value)} />
                                                                <TextField fullWidth label="URL SSH Web" variant="standard" margin="normal" value={urlSshWeb} onChange={(e) => setUrlSshWeb(e.target.value)} />
                                                                <TextField fullWidth label="URL Ping Rede" variant="standard" margin="normal" value={urlPingRede} onChange={(e) => setUrlPingRede(e.target.value)} />
                                                                <TextField fullWidth label="URL AgentDVR" variant="standard" margin="normal" value={urlAgentDVR} onChange={(e) => setUrlAgentDVR(e.target.value)} />

                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}

                                            {/* Painel Integração Sigma para Módulo Sonoro e Módulo PGM na aba Informações Iniciais */}
                                            {(moduloSonoroSelecionado || moduloPgmSelecionado || (equipamento && (equipamento.modulo_sonoro || equipamento.modulo_pgm || equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.tipo_equipamento_area_tecnica === 30)) || (insumoSelecionado && (
                                                insumoSelecionado.tipo_equipamento_area_tecnica === 0 || insumoSelecionado.tipo_equipamento_area_tecnica === 30 ||
                                                (insumoSelecionado.insumo && (insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 0 || insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 30))
                                            ))) && (
                                                <Grid item xs={12} style={{ marginTop: 20, marginBottom: 20, width: '100%' }}>
                                                    <Paper variant="outlined" style={{ padding: 20, backgroundColor: darkMode ? '#1e293b' : '#fcfcfc', border: darkMode ? '1px solid #334155' : '1px solid #c5c5c5', borderRadius: 8 }}>
                                                        <Typography variant="h6" style={{ marginBottom: 15, fontWeight: 'bold', color: darkMode ? '#ffffff' : '#1e293b' }}>
                                                            Integração Sigma
                                                        </Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={integradoSigma}
                                                                            onChange={e => setIntegradoSigma(e.target.checked)}
                                                                            sx={{ color: darkMode ? '#94a3b8' : undefined, '&.Mui-checked': { color: '#0ea5e9' } }}
                                                                        />
                                                                    }
                                                                    label={<span style={{ color: darkMode ? '#f1f5f9' : '#1e293b', fontWeight: 500 }}>Integrado ao Sigma</span>}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={notificarArmeSigma}
                                                                            onChange={e => setNotificarArmeSigma(e.target.checked)}
                                                                            sx={{ color: darkMode ? '#94a3b8' : undefined, '&.Mui-checked': { color: '#0ea5e9' } }}
                                                                        />
                                                                    }
                                                                    label={<span style={{ color: darkMode ? '#f1f5f9' : '#1e293b', fontWeight: 500 }}>Notificar Arme ao Sigma</span>}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={notificarDesarmeSigma}
                                                                            onChange={e => setNotificarDesarmeSigma(e.target.checked)}
                                                                            sx={{ color: darkMode ? '#94a3b8' : undefined, '&.Mui-checked': { color: '#0ea5e9' } }}
                                                                        />
                                                                    }
                                                                    label={<span style={{ color: darkMode ? '#f1f5f9' : '#1e293b', fontWeight: 500 }}>Notificar Desarme ao Sigma</span>}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={notificarAlarmeSigma}
                                                                            onChange={e => setNotificarAlarmeSigma(e.target.checked)}
                                                                            sx={{ color: darkMode ? '#94a3b8' : undefined, '&.Mui-checked': { color: '#0ea5e9' } }}
                                                                        />
                                                                    }
                                                                    label={<span style={{ color: darkMode ? '#f1f5f9' : '#1e293b', fontWeight: 500 }}>Notificar Alarme ao Sigma</span>}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ marginTop: 15 }}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={salvar}
                                                                    disabled={botaoClicado}
                                                                    startIcon={<SwapHorizIcon />}
                                                                >
                                                                    {botaoClicado ? "Atualizando..." : "Atualizar Informações"}
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                            )}

                                        </Grid>


                                    </Grid>

                                    <Grid
                                        value={value}
                                        index={1}
                                        style={{ margin: 1, padding: 1, width: '100%' }}

                                    >






                                        <Grid
                                            container
                                            direction="row"
                                            item xs={12} spacing={2}
                                        >
                                            <Grid item xs={4}>
                                                <TextField

                                                    id="rotaCamera"
                                                    variant="standard"
                                                    name="rotaCamera"
                                                    fullWidth
                                                    label="Rota Câmera"
                                                    value={rotaCamera}
                                                    onChange={e => setRotaCamera(e.target.value)}
                                                />
                                            </Grid>

                                        </Grid>

                                        {((equipamento && (equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.modulo_pgm)) ||
                                          (insumoSelecionado && (insumoSelecionado.tipo_equipamento_area_tecnica === 0 || insumoSelecionado.insumo?.tipo_equipamento_area_tecnica === 0)) ||
                                          moduloPgmSelecionado) && (
                                            <ModuloPGM
                                                equipamento={{
                                                    ...equipamento,
                                                    modulo_pgm: moduloPgmSelecionado || equipamento?.modulo_pgm,
                                                    tipo_equipamento_area_tecnica: 0
                                                }}
                                                moduloPgm={moduloPgmSelecionado || equipamento?.modulo_pgm}
                                                darkMode={darkMode}
                                            />
                                        )}


                                        {insumoSelecionado && (insumoSelecionado.tipo_equipamento_area_tecnica === 30) &&
                                            <ModuloSonoro
                                                equipamento={equipamento}
                                            />
                                        }


                                    </Grid>


                                
                                            {equipamento.tipo_equipamento_area_tecnica === 80 && equipamento.modulo_sonoro && (
                                                <div value={value} index={1} style={{ padding: 20 }}>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField fullWidth label="Usuário da Câmera" value={cameraUsuario} onChange={(e) => setCameraUsuario(e.target.value)} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField fullWidth label="Senha da Câmera" type="password" value={cameraSenha} onChange={(e) => setCameraSenha(e.target.value)} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <FormControl fullWidth>
                                                                <InputLabel>Status (1 = Habilitado)</InputLabel>
                                                                <Select value={cameraStatus} onChange={(e) => setCameraStatus(e.target.value)}>
                                                                    <MenuItem value={1}>Habilitado</MenuItem>
                                                                    <MenuItem value={0}>Desabilitado</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        
                                                        {[{label: 'Prioridade 1', val: busca1, set: setBusca1}, {label: 'Prioridade 2', val: busca2, set: setBusca2}, {label: 'Prioridade 3', val: busca3, set: setBusca3}, {label: 'Prioridade 4', val: busca4, set: setBusca4}].map((b, idx) => (
                                                            <Grid item xs={12} sm={6} key={idx}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel>Modo de Busca - {b.label}</InputLabel>
                                                                    <Select value={b.val} onChange={(e) => b.set(e.target.value)}>
                                                                        <MenuItem value="MEMORIA_CAMERA_RTSP">Memória Câmera RTSP</MenuItem>
                                                                        <MenuItem value="MEMORIA_CAMERA_HTTP">Memória Câmera HTTP</MenuItem>
                                                                        <MenuItem value="NVR">NVR</MenuItem>
                                                                        <MenuItem value="LOCAL">Local</MenuItem>
                                                                        <MenuItem value="DESATIVADO">Desativado</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </div>
                                            )}
</SwipeableViews>


                            </Grid>

                        </Grid>


                    </React.Fragment>


                </Container >
            }


            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px', // Ajuste a altura conforme necessário
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',

                    }
                }}
            />


                </div>
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}



